import { Group } from "three"

import { Vertices } from "./graph/vertex"
import { Edge } from "./graph/edge"


export { Graph }

class Graph extends Group {
    #clock
    #count = 100
    #edges = new Map()
    #vertices

    #addEdgeToDependencyMap(edge, vertex1, vertex2) {
        [vertex1, vertex2].forEach(
            (vertex, index) => {
                (this.#edges.get(vertex) ?? this.#edges.set(vertex, []).get(vertex))
                    .push((fixture) => edge.update(index, fixture))
            }
        )
    }

    #createEdges() {
        const edges = []

        for (let vertex1 = 0; vertex1 < this.#count; vertex1++) {
            const vertex2 = this.#getVertex2(vertex1)

            if (this.#edges.get(vertex1)?.length + this.#edges.get(vertex2)?.length > 2) continue

            const edge = new Edge(
                {
                    position: this.#vertices.getVertexAttribute(vertex1, "position"),
                    colour: this.#vertices.getVertexAttribute(vertex1, "color")
                },
                {
                    position: this.#vertices.getVertexAttribute(vertex2, "position"),
                    colour: this.#vertices.getVertexAttribute(vertex2, "color")
                },
            )

            this.#addEdgeToDependencyMap(edge, vertex1, vertex2)
            edges.push(edge)
        }

        return edges
    }

    #getVertex2(vertex1) {
        const maxIteration = 10 // to not run indefinetly

        for (let i = 0; i < maxIteration; i++) {
            // pseudo-random numbers are fine here as they
            // are only used to select a random vertex.
            // eslint-disable-next-line sonarjs/pseudo-random
            const vertex2 = Math.floor(Math.random() * this.#count)

            if (vertex1 == vertex2 || this.#edges.get(vertex2)?.length > 2) continue

            return vertex2
        }

        console.warn("overrun max iterations")
        return vertex1
    }

    #tick() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

        this.rotateY(Math.PI * .000003 * this.#clock.delta)
        this.rotateZ(Math.PI * .000003 * this.#clock.delta)

        // pseudo-random numbers are fine here as they
        // are only used to select a random vertex.
        // eslint-disable-next-line sonarjs/pseudo-random
        const vertex = Math.floor(Math.random() * this.#count)
        const edges = this.#edges.get(vertex) ?? []

        this.#vertices.moveVertex(vertex, edges)
    }

    constructor(clock) {
        super()
        this.translateZ(-18)

        this.#vertices = new Vertices(this.#count, clock)
        this.add(this.#vertices, ...this.#createEdges())

        this.#clock = clock
        this.#clock.addEventListener("tick", () => this.#tick())
    }

    setCurrentChapter(id) {
        this.scale.multiplyScalar(.1)
        this.#vertices.setCurrentChapter(id, this.#edges)
        this.scale.multiplyScalar(10)
    }
}